// Sends a notification email via EmailJS (https://www.emailjs.com) — no backend needed.
// Configure your Service ID / Template ID / Public Key in public/index.html
// (window.EMAILJS_CONFIG). Until that's filled in, this fails silently (logs a
// console warning) so registration itself is never blocked by email being unset up.


// export function sendMail({ to_email, to_name, subject, message }) {
//   const cfg = typeof window !== "undefined" && window.EMAILJS_CONFIG;
//   if (!cfg || !window.emailjs || cfg.serviceId === "YOUR_SERVICE_ID") {
//     console.warn("EmailJS not configured yet — skipping email notification. See public/index.html.");
//     return Promise.resolve();
//   }
//   return window.emailjs
//     .send(cfg.serviceId, cfg.templateId, { to_email, to_name, subject, message }, cfg.publicKey)
//     .catch(err => console.error("Email notification failed:", err));
// }

import emailjs from "@emailjs/browser";

const SERVICE_ID = "service_7fdwo7k";
const TEMPLATE_ID = "template_31leuiq";
const PUBLIC_KEY = "TNla_hnNziAezrT6l";

export function sendMail({ to_email, to_name, subject, message }) {
  console.log("📧 EmailJS sending...");
  console.log("Service:", SERVICE_ID);
  console.log("Template:", TEMPLATE_ID);
  console.log("To:", to_email);

  return emailjs
    .send(
      SERVICE_ID,
      TEMPLATE_ID,
      {
        to_email,
        to_name,
        subject,
        message,
      },
      PUBLIC_KEY
    )
    .then((response) => {
      console.log("✅ EmailJS SUCCESS:", response.status, response.text);
      return response;
    })
    .catch((error) => {
      console.error("❌ EmailJS ERROR OBJECT:", error);
      console.error("❌ Error status:", error?.status);
      console.error("❌ Error text:", error?.text);
      console.error("❌ Error message:", error?.message);

      // IMPORTANT: error ko throw nahi karna
      // Registration ko EmailJS ki wajah se crash nahi hone denge.
      return null;
    });
}